export const BREAK_POINT_MIN = 360;
export const BREAK_POINT_TABLET = 768;
export const BREAK_POINT_MAX = 1140;
export const BANGLA_NUMBER_ARRAY = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];
export const ENGLISH_NUMBER_ARRAY = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

export const MEDIA_TABLET = "(min-width: " + BREAK_POINT_TABLET + ")";

export const ENG_GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.prothomalo.english";
export const ENG_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/english-news-prothom-alo/id1289463331";
export const BN_GOOGLE_PLAYSTORE = "";
export const BN_APPLE_PLAYSTORE = "";

export const listValue = [
  { key: "bangla", value: "বাংলা" },
  { key: "english", value: "English" }
];

export const storyTemplatesList = [
  { key: "all", value: "All" },
  { key: "text", value: "Text" },
  { key: "photo", value: "Photo" },
  { key: "video", value: "Video" },
  { key: "live-blog", value: "Live-Blog" },
  { key: "polls", value: "Polls" }
];

export const sortingList = [
  { key: "default", value: "Relevant" },
  { key: "latest-published", value: "Latest" },
  { key: "published-at:asc", value: "Oldest" }
];
